import LTR from "@brand-icons/ploomg4/accessories-front-pannel/accessories-front-pannel-ltr.svg";

import { iconFactory } from "../iconFactory";

export const AccessoriesFrontPannelIcon = iconFactory("AccessoriesFrontPannelIcon", LTR);
